import Tooltip, { TooltipProps } from '@mui/material/Tooltip';

export function CustomTooltip(props: TooltipProps) {
  return (
    <Tooltip
      {...props}
      arrow
      enterDelay={100}
      leaveDelay={100}
      componentsProps={{
        tooltip: {
          sx: {
            color: 'white',
            fontSize: 12,
            p: 1,
            borderRadius: 1,
          },
        },
      }}
    />
  );
}
